import { Component, OnInit, AfterViewInit, ɵConsole } from '@angular/core';
import { ChannelService, ChannelEvent } from '../services/channel.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ClientService } from '../services/client.service';
import { ClientLocation } from '../models/clientLocation';
import { SearchPackage, SearchRecord } from '../models/searchPackage';
import { SearchPackageService } from '../services/search-package.service';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-package-manager',
  templateUrl: './package-manager.component.html',
  styleUrls: ['./package-manager.component.less']
})
export class PackageManagerComponent implements OnInit, AfterViewInit {
  channels : ChannelService;
  clientId : number;
  locations : Array<ClientLocation>;
  selectedLocation : ClientLocation;
  package : SearchPackage;
  selectedSearch : SearchRecord;
  constructor(public toast: ToastrService, channels : ChannelService,public location : Router, public activatedRoute: ActivatedRoute, public clientSrv : ClientService, public pkgSrv : SearchPackageService,  public auth: AuthService) { 
    this.channels = channels;
    this.package = new SearchPackage();
    this.package.searches = new Array<SearchRecord>()
    this.auth.roleFetchComplete.subscribe((dta: any)=>{
      console.log('roles fetched');
      // TODO : pass the status code so know if we should actually redirect(401).
      if(dta.status == 401)this.location.navigateByUrl('/auth');
      else if(dta.status == 500) this.toast.error(`error ${dta}`);
  });
  }

  error : boolean = false
  errorMsg: string;
  ngAfterViewInit(): void {
  }

  addSearchToPackage(val:any){
    this.package.searches.push(val.value);
    console.log(val);
    console.log(this.selectedSearch);
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(
      (params: ParamMap) =>{
        this.clientId = parseInt(params.get('client'),10);
        this.auth.postLoginRedirect = '/packages/'+this.clientId;
        if(!localStorage.getItem('STP-JWT')){
          this.auth.hasRedirect = true;
          this.location.navigateByUrl('/auth')
        }else {
          this.auth.GetUsersRoles();
        }
      });
  }

  update(val : any){
    this.package[val.name] = val.value;
    console.log(val)
  }

  setBool(val : boolean)
  {
    this.package.reusable = val;
  }

  setLocation(loc: any){
    this.selectedLocation = loc.value;
    // this.selectedLocation = this.locations.filter(l => { return l.id == loc.value})[0];
    this.package.clientLocationId = this.selectedLocation.id;
    console.log(this.package);
    console.log(this.selectedLocation)
  }

  savePackage(){
    if(this.package.searches.length == 0){
      this.error = true;
      this.errorMsg = 'please select the searches you would like applied in this package.'
    }else{
      this.package.clientId = this.clientId;
      if(this.auth.UserInRole("CRA")) this.package.isDefaultPackage = true;
      this.clientSrv.SaveSearchPackage(this.package).subscribe(ev =>{
        console.log(`Saved Search Package ${ev}`);
        this.toast.success('your search package was saved. ', '', {timeOut:5000});
        this.location.navigateByUrl("/packages/list/" + this.clientId);
      },(err: any)=>{
        this.toast.error('There was a problem saving your package.. please call support.')
      })
    }
   
    console.log(this.package);
  }

  // go() {
  //   var evt = new ChannelEvent();
  //   evt.channelName = "Send";
  //   evt.data = "Sent to Sub 1";
  //   this.channels.publish(evt);

  //   evt.channelName = "Send";
  //   evt.data = "Sent to Sub 2";
  //   this.channels.publish(evt);
  // }


}
